export default __webpack_public_path__ + "static/media/JS.420ea398.jpg";